import { z } from "@hono/zod-openapi";
import { ArrivalStopRoleSchema } from "../../movement/arrival";

/**
 * What `forecastLate` and `forecastOnTime` both state: the stop, its appointment, and the forecast that crossed it.
 *
 * Every field but the driver's membership is read off the forecast row that carried the transition, so the event
 * states what the board showed at the moment the stop's risk changed. The instants are zod's own ISO validators, as
 * `occurredAt` is: this package depends on nothing of Storyboard's.
 */
export const appointmentForecastFacts = {
  stopName: z.string(),
  /** Null when the route's stop names no city. */
  city: z.string().nullable(),
  stopRole: ArrivalStopRoleSchema,
  storyboardRouteStopId: z.string(),
  storyboardRouteId: z.string(),
  /** The end of the stop's appointment window, the instant the forecast is measured against. */
  appointmentEnd: z.iso.datetime(),
  /** The arrival the forecast projected at the row that carried the transition. */
  projectedArrival: z.iso.datetime(),
  /**
   * The membership of the route's driver of record at the instant the event was written.
   *
   * Attribution falsework, carried in version 1 only: a stop event is attributed to the membership that completed it,
   * which these events leave null, so the web places the event under its driver by this fact until the
   * vehicle-assignment attribution of the design's second stage is the rule. The second version of each kind drops it.
   */
  driverWorkspaceMembershipId: z.string(),
};
